import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  FaRegCommentDots,
  FaUsers,
  FaUserCog,
  FaThLarge,
  FaChartLine,
} from 'react-icons/fa';
import PortalNavbar from './PortalNavbar';
import './Hub.css';

/**
 * Entry point del portale: l'utente sceglie una sezione.
 * Replica il mockup di riferimento (card 2x2 centrata).
 * Tutte le card navigano verso rotte reali e registrate in App.js.
 */
const SECTIONS = [
  {
    key: 'chat',
    title: 'Chat',
    desc: 'Ricerca candidati e conversazioni',
    to: '/chat',
    icon: <FaRegCommentDots />,
    tone: 'blue',
  },
  {
    key: 'candidati',
    title: 'Gestione Candidati',
    desc: 'Anagrafica e profili CV',
    to: '/metadata',
    icon: <FaUsers />,
    tone: 'amber',
  },
  {
    key: 'utenti',
    title: 'Gestione Utenti',
    desc: 'Account, ruoli e permessi',
    to: '/users',
    icon: <FaUserCog />,
    tone: 'violet',
  },
  {
    key: 'dashboard',
    title: 'Dashboard',
    desc: 'Statistiche e analisi aziendale',
    to: '/dashboard',
    icon: <FaThLarge />,
    tone: 'green',
  },
];

function Hub() {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <div className="hub-page">
      <PortalNavbar showLogout />

      <main className="hub-main">
        <section className="hub-card ds-card">
          <header className="hub-card-header">
            <h1 className="hub-greeting">{user?.username || 'Benvenuto'}</h1>
            <p className="hub-subtitle">Seleziona una sezione per continuare</p>
          </header>

          <div className="hub-grid">
            {SECTIONS.map((s) => (
              <button
                key={s.key}
                type="button"
                className="hub-tile ds-card ds-card-interactive"
                onClick={() => navigate(s.to)}
              >
                <span className={`hub-tile-icon tone-${s.tone}`}>{s.icon}</span>
                <span className="hub-tile-title">{s.title}</span>
                <span className="hub-tile-desc">{s.desc}</span>
              </button>
            ))}
          </div>

          <button
            type="button"
            className="hub-bigbtn"
            onClick={() => navigate('/dashboard-multifitting')}
          >
            <span className="hub-bigbtn-icon"><FaChartLine /></span>
            <span className="hub-bigbtn-text">
              <span className="hub-bigbtn-title">Dashboard MultiFitting</span>
              <span className="hub-bigbtn-desc">Ranking candidati, cluster e annunci · fitting cross-cluster</span>
            </span>
            <span className="hub-bigbtn-arrow">→</span>
          </button>
        </section>
      </main>
    </div>
  );
}

export default Hub;
